import { getRewardCondition } from './getRewardCondition';
export async function getFriendRewardCondition(context, program) {
  const reward = program.referredFriendReward;
  if (!reward) {
    return '';
  }
  return getRewardCondition(context, reward);
}
//# sourceMappingURL=getFriendRewardCondition.js.map